export default __webpack_public_path__ + "static/media/ma.652a7b03.jpg";